import styles from "./FeeExplanation.module.scss";
import { Table } from "reactstrap";

const FeeExplanation = () => {
  const data = [
    { type: "Transaction Fee", desc: "Fee per sale", rateAmount: "2.9% + $0.30", conditions: "Per transaction" },
    { type: "Subscription Fee", desc: "Monthly platform access fee", rateAmount: "$29.99", conditions: "Monthly" },
    { type: "Refund Fee", desc: "Fee for processed refunds", rateAmount: "5%", conditions: "Per refund" },
    { type: "Advertising Fee", desc: "Cost per click on ads", rateAmount: "Min $0.50", conditions: "$600" },
    { type: "Others", desc: "Any other miscellaneous fees", rateAmount: "$0.00", conditions: "$600" },
  ];

  return (
    <section>
      <div className="fw-semibold fs-5 mt-3 mb-2">Fee Explanation</div>
      <div className="table-responsive mb-3">
        <Table hover className={styles.feeTable}>
          <thead className={styles.headOrange}>
            <tr>
              <th>Fee Type</th>
              <th>Description</th>
              <th>Rate/Amount</th>
              <th>Conditions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} className={styles.dataRow}>
                <td className={styles.column}>{item.type}</td>
                <td className={styles.column}>{item.desc}</td>
                <td className={styles.column}>{item.rateAmount}</td>
                <td className={styles.column}>{item.conditions}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </section>
  );
};

export default FeeExplanation;